/** The setup name from a strategy order comment (`<label>:<setup>`), or "—".
 *  Mirrors the backend's `tagging.parse_comment`: broker rewrites like
 *  `[sl 2345.1]` are not ours. */
export function parseSetup(comment: string | undefined | null): string {
  if (!comment || comment.startsWith("[")) return "—";
  const i = comment.indexOf(":");
  return i > 0 && i < comment.length - 1 ? comment.slice(i + 1) : "—";
}
